import { CurrencyEnum } from '../interfaces/plan.interface';

export const SUPPORTED_CURRENCIES = {
  [CurrencyEnum.USD]: {
    code: CurrencyEnum.USD,
    symbol: '$',
    name: 'US Dollar',
    countries: ['US', 'CA', 'AU', 'NZ', 'SG', 'HK', 'BR', 'IN', 'ID', 'JP', 'MY', 'MX', 'TH', 'AE'],
    default: true,
    bookCost: 12.95,
    shippingCost: 6.99,
    additionalPageFee: 0.95,
    decimalPlaces: 2,
  },
  [CurrencyEnum.EUR]: {
    code: CurrencyEnum.EUR,
    symbol: '€',
    name: 'Euro',
    countries: ['DE', 'FR', 'IT', 'ES', 'NL', 'BE', 'AT', 'IE', 'FI', 'PT', 'GR', 'CY', 'MT', 'SI', 'SK', 'EE', 'LV', 'LT', 'LU', 'BG', 'CZ', 'DK', 'HU', 'NO', 'PL', 'RO', 'SE', 'CH'],
    default: false,
    bookCost: 11.95,
    shippingCost: 6.49,
    additionalPageFee: 0.89,
    decimalPlaces: 2,
  },
  [CurrencyEnum.GBP]: {
    code: CurrencyEnum.GBP,
    symbol: '£',
    name: 'British Pound',
    countries: ['GB', 'GI'],
    default: false,
    bookCost: 10.95,
    shippingCost: 5.99,
    additionalPageFee: 0.79,
    decimalPlaces: 2,
  }
};

export const getCurrencyConfig = (currency: CurrencyEnum) => {
  return SUPPORTED_CURRENCIES[currency];
};

export const getDefaultCurrency = (): CurrencyEnum => {
  return Object.values(SUPPORTED_CURRENCIES).find(config => config.default)?.code || CurrencyEnum.USD;
};

export const formatCurrency = (amount: number, currency: CurrencyEnum): string => {
  const config = getCurrencyConfig(currency);
  return `${config.symbol}${(+amount || 0)?.toFixed(2)}`;
};

export const getCurrencyForCountry = (countryCode: string | undefined): CurrencyEnum | undefined => {
  if (!countryCode) {
    return;
  }
  // Check each currency's supported countries
  for (const [currency, config] of Object.entries(SUPPORTED_CURRENCIES)) {
    if (config.countries.includes((countryCode || '').toUpperCase())) {
      return currency as CurrencyEnum;
    }
  }
  
  // Default to USD if country not found
  return CurrencyEnum.USD;
};

export const getCountryCurrencyMapping = (): Record<string, CurrencyEnum> => {
  const mapping: Record<string, CurrencyEnum> = {};
  
  for (const [currency, config] of Object.entries(SUPPORTED_CURRENCIES)) {
    for (const countryCode of config.countries) {
      mapping[countryCode] = currency as CurrencyEnum;
    }
  }
  
  return mapping;
}; 